import apiClient from './client';
import type { SessionResponse } from '../types/problems';
import type { ThirdLevelBidSessionResponse } from '../types/thirdLevelBid';
import type { ThirdLevelBidReviewCategory } from '../types/thirdLevelBidReview';

/**
 * Read-only data calls for the "3rd level bids - Review" page (feature 017). Hits the feature's
 * own endpoint and adapts the `{ items }` wire shape (the reused 013 item DTO) to the shared
 * `{ problems }` SessionResponse so the existing presentational components are unchanged.
 *
 * This module is read-only: there is no submit/assign/skip call (FR-003).
 */
export const thirdLevelBidReviewApi = {
  /**
   * The eligible 3rd-level-decision pool for the chosen review category, ordered ascending by id
   * (FR-013). `incorrect-jim` (default) returns the hands Jim answered incorrectly; `all` returns
   * the whole eligible pool. Each item carries Jeff's actual call and (where present) Jim's answer.
   */
  getCandidates: async (category: ThirdLevelBidReviewCategory): Promise<SessionResponse> => {
    const response = await apiClient.get<ThirdLevelBidSessionResponse>(
      '/third-level-bid-review/candidates',
      { params: { category } },
    );
    return { problems: response.data.items, totalAvailable: response.data.totalAvailable };
  },
};
